/**
 * 認証用データストア
 *  
 */
// 初期値
const getDefaultState = () => {
    return {
        accessToken: '',
        refreshToken: '',
        loggedUserInfo: {id: "", name:"", companyname:"", deptname:""},
        rollAuthenticated: [],
        loginIdAfterRegistAccount: "",
    };
};
// 初期値取得
const state = getDefaultState();

const getters = {

    getAccessToken(state) {
        return state.accessToken;
    },
    getRefreshToken(state) {
        return state.refreshToken;
    },
    getLoggedUserInfo(state) {
        return state.loggedUserInfo;
    },
    getRollAuthenticated(state) {
        return state.rollAuthenticated;
    },
    getLoginIdAfterRegistAccount(state) {
        return state.loginIdAfterRegistAccount;
    },
};
const mutations = {
    accessToken(state, info) {
        state.accessToken = info;
    },
    refreshToken(state, info) {
        state.refreshToken = info;
    },
    loggedUserInfo(state, info) {
        state.loggedUserInfo = info;
    },
    rollAuthenticated(state, info) {
        state.rollAuthenticated = info;
    },
    loginIdAfterRegistAccount(state, info) {
        state.loginIdAfterRegistAccount = info;
    },
  /**
   * state初期化
   * @param {ストア}} state 
   */
   resetState(state) {
    Object.assign(state, getDefaultState());
  },
};
const actions = {
    setAccessToken(context, info) {
        context.commit("accessToken", info);
    },
    setRefreshToken(context, info) {
        context.commit("refreshToken", info);
    },
    setLoggedUserInfo(context, info) {
        context.commit("loggedUserInfo", info);
    },
    setRollAuthenticated(context, info) {
        context.commit("rollAuthenticated", info);
    },
    setLoginIdAfterRegistAccount(context, info) {
        context.commit("loginIdAfterRegistAccount", info);
    },
};
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
  };